import type { QueryKey } from "@tanstack/react-query";
import { QueryClient } from "@tanstack/react-query";
import type { ResponseError } from "../types";

export const MAX_FAILURE_COUNT = 3;

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        // TODO: extract error and pass to the parameter
        if (!shouldRetryHookOnError(error as any)) {
          return false;
        }

        return failureCount < MAX_FAILURE_COUNT;
      },
    },
  },
});

export const shouldRetryHookOnError = (error: ResponseError) =>
  error.code < 400 || error.code > 499;

export const buildQueryKey = <TVariable = any>(
  key: string,
  variables?: TVariable,
) => (variables === undefined ? [key] : [key, variables]);

export const invalidateQueries = (queryKey: QueryKey, exact = false) => {
  if (exact) {
    queryClient.invalidateQueries({
      queryKey,
      exact,
    });
    return;
  }

  const queryCache = queryClient.getQueryCache();
  const queries = queryCache.findAll({ queryKey });

  queries.forEach((query) => {
    queryCache.remove(query);
  });
};
